// The slow-connection indicator in the root layout, under the offline banner's spot: shown while a
// request has waited longer than SLOW_AFTER_MS. Offline wins: the offline banner explains the wait.
import { StyleSheet, View } from "react-native";

import { useSlowNetwork } from "@/api/slowRequests";
import { makeStyles } from "@/theme/makeStyles";
import { BrandLoader } from "@/ui/BrandLoader";
import { Text } from "@/ui/Text";

import { useNetworkStatus } from "./useNetworkStatus";

export const SLOW_MESSAGE = "Slow connection. Still loading…";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    banner: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: t.space.sm,
      paddingHorizontal: t.space.lg,
      paddingVertical: t.space.xxs,
      backgroundColor: t.color.surface,
      borderBottomWidth: 1,
      borderBottomColor: t.color.border,
    },
  }),
);

export function SlowNetworkBanner() {
  const styles = useStyles();
  const slow = useSlowNetwork();
  const { online } = useNetworkStatus();
  if (!slow || !online) return null;
  return (
    <View
      style={styles.banner}
      testID="slow-network-banner"
      role="status"
      aria-live="polite"
    >
      <BrandLoader width={44} />
      <Text size="sm" tone="muted">
        {SLOW_MESSAGE}
      </Text>
    </View>
  );
}
